<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="refresh_btn">
          <LoadingButton
            title="Обновить"
            className="btn btn-outline-info btn-xs"
            :onClick="() => $refs?.watchSuppliers?.getCodes()"
            :loading="loading"
            :color="$constants.PRIMARY_COLOR"
          />
        </div>
        <table class="table mt-0 table-sm">
          <thead>
          <tr>
            <th>Препарат</th>
            <th>Спрос</th>
            <th>Ср.цена</th>
            <th>Наличие</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td><strong>{{ record?.drug?.title }}</strong></td>
            <td>{{ record.call }}</td>
            <td>{{ record.price }}</td>
            <td>{{ record.stores }}</td>
          </tr>
          </tbody>
        </table>
        <div>
          <!--          <PairCodes :record003Id="record.drug.id"/>-->
          <WatchUtekaTask ref="watchSuppliers" :drug="record.drug"/>
        </div>
      </div>
    </div>
    <div class="flex justify-content-between">
      <div class="flex-grow-1">
        <button v-if="!addRecordComment" type="button" @click="addRecordComment = true" class="btn btn-default">Добавить
          комментарий к записи
        </button>
        <template v-if="showHideReasonBlock">
          <textarea type="text" rows="3" v-model="hideReasonText" placeholder="Комментарий к записи скрытия"
                    class="form-control"/>
        </template>
      </div>
      <div class="flex flex_gap_10">
        <LoadingButton
          title="Сохранить и скрыть"
          type="button"
          :loading="saveLoading"
          :color="$constants.SUCCESS_COLOR"
          :onClick="() => saveTasks(true)"
          className="btn btn-outline-success"
        />
        <LoadingButton
          title="Сохранить условия"
          type="button"
          :loading="saveLoading"
          :color="$constants.SUCCESS_COLOR"
          :onClick="() => saveTasks()"
          className="btn btn-success"
        />
      </div>
    </div>

    <div class="card mt-2" v-if="addRecordComment">
      <div class="card-header"><h5>Комментарий к записи</h5></div>
      <div class="card-body">
        <textarea v-model="recordDetails.comment.value" placeholder="Комментарий к препарату 003sm" class="form-control"
                  rows="2"/>
        <div class="text-right mt-1">
          <LoadingButton
            title="Сохранить комментарий"
            type="button"
            :loading="saveLoading"
            :color="$constants.SUCCESS_COLOR"
            :onClick="() => updateRecordDetail('comment')"
            className="btn btn-outline-success"
          />
        </div>
      </div>
    </div>

    <div class="card mt-2">
      <div class="card-header">
        <h6>Действия по препарату</h6>
      </div>
      <div class="card-body">
        <div class="flex">
          <div v-for="(t, alias, i) in taskOptions" :key="i" class="mr-1">
            <button type="button" @click="selectedTasks[alias] = !selectedTasks[alias]"
                    :class="{'btn btn-outline-primary': true, 'active':selectedTasks[alias] }">
              <input type="checkbox" autocomplete="off">
              {{ t?.title }}
            </button>
          </div>
          <div class="flex flex-grow-1 justify-content-end flex_gap_10">
            <button v-if="task?.type_id !== 4" @click="actionByModal('AddStatRecordToModeration')" type="button"
                    class="btn btn-default">на
              модерацию
            </button>
            <template v-if="task?.type_id !== -1">
              <button @click="actionByModal('AddStatToBlackList')" type="button" class="btn btn-default">черный список
              </button>
              <button @click="actionByModal('NoSupplierStatsTask')" type="button" class="btn btn-default">нет поставки
              </button>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div v-for="(a, alias) in selectedTasks" v-if="a && taskOptions[alias]" class="mt-1 border p-1 card shadow-sm">
      <div class="card-header bg-info">
        <h5>Задача <strong>{{ taskOptions[alias]?.title }}</strong></h5>
      </div>
      <div class="card-body p-2">
        <template v-if="alias === 'createNewDrug'">
          <NewDrugTask ref="createNewDrug" :taskData="newTasksData[alias]"/>
        </template>
        <template v-if="alias === 'pairDrug'">
          <PairDrug ref="pairDrug"
                    :drug="record.drug"
                    :taskData="newTasksData[alias]"
                    :pairedDrugs="record.drug.related_drugs"/>
        </template>
        <template v-if="alias === 'blackList'">
          <BlackListMSStat ref="blackList" :getConditionTasks="() => getConditionTasks()"
                           :taskData="newTasksData[alias]" :record003Id="record.drug.id"/>
        </template>
        <template v-if="alias === 'pairCodes'">
          <PairCodes :record003Id="record.drug.id"/>
        </template>
        <template v-if="alias === 'storeCall'">
          <ManufacturerDrugInfoTask :record="record"
                                    :task="(record.drug.tasks ?? []).find((t) => t.type_id === 22) ?? {}"/>
        </template>
        <div v-if="commentsIn.includes(alias)" class="form-group mt-1 p-1">
          <label>Комментарий</label>
          <textarea v-model="newTasksData[alias].comment" class="form-control" rows="2"></textarea>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import PairDrug from "@/views/statistics/components/tasksType/PairDrug.vue";
import WatchUtekaTask from "@/views/statistics/components/tasksType/WatchUtekaTask.vue";
import NewDrugTask from "@/views/statistics/components/tasksType/NewDrugTask.vue";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";
import BlackListMSStat from "@/views/statistics/components/tasksType/BlackListMSStat.vue";
import PairCodes from "@/views/statistics/components/tasksType/PairCodes.vue";
import SMDrugDetails from "@/components/suppliers/SMDrugDetails.vue";
import ManufacturerDrugInfoTask from "@/views/tasks/types/ManufacturerDrugInfoTask.vue";
import {customUpdateData} from "@/eventsBus";

export default {
  components: {
    ManufacturerDrugInfoTask,
    SMDrugDetails, PairCodes, BlackListMSStat, LoadingButton, NewDrugTask, WatchUtekaTask, PairDrug
  },
  props: ['record', 'task', 'closeDrawer'],
  data() {
    return {
      commentsIn: ['createNewDrug', 'updatePrices'],
      loading: false,
      addRecordComment: false,
      saveLoading: false,
      hideReasonText: '',
      showHideReasonBlock: false,
      selectedTasks: {},
      newTasksData: {},
      recordDetails: {},
      taskOptions: {
        createNewDrug: {
          title: 'Создать новый препарат',
        },
        pairDrug: {
          title: 'Привязать к препарату РК',
          icon: 'icon-fa icon-fa-plus-square'
        },
        storeCall: {
          title: 'Позвонить по наличию',
          icon: 'icon-fa icon-fa-phone-square'
        },
        pairCodes: {
          title: 'Привязать артикулы UTEKA',
          icon: 'icon-fa icon-fa-barcode'
        },
        // updatePrices: {
        //   title: 'Описать цены закупок',
        //   icon: 'icon-fa icon-fa-money'
        // },
        // watchSuppliers: {
        //   title: 'Мониторинг справочных',
        //   icon: 'icon-fa icon-fa-eye'
        // },
        // blackList: {
        //   title: 'Добавить в черный список',
        //   icon: 'icon-fa icon-fa-eye'
        // },
      },
    }
  },
  watch: {
    'record': {
      handler: function (val, oldVal) {
        this.updateSavedDetails();
      },
      deep: true
    },
  },
  created() {
    this.selectedTasks = Object.keys(this.taskOptions).reduce((acc, t) => {
      acc[t] = false;
      return acc;
    }, {watchSuppliers: true});
    this.newTasksData = Object.keys(this.taskOptions).reduce((acc, t) => {
      acc[t] = {};
      return acc;
    }, {});
    this.updateSavedDetails();
  },
  methods: {
    updateSavedDetails() {
      this.newTasksData.createNewDrug = {drugDetails: {title: this.record?.drug?.title}};
      this.recordDetails = {comment: {value: ''}};
      (this.record?.details ?? []).forEach((d) => {
        if (d.group !== 'users_data') return;
        this.recordDetails[d.alias] = {...d};
      })
      if (this.recordDetails.comment.value) this.addRecordComment = true;
    },
    actionByModal(alias) {
      let header = 'Модальное окно';
      switch (alias) {
        case 'AddStatToBlackList':
          header = 'Добавить препарат в черный список';
          break;
        case 'NoSupplierStatsTask':
          header = 'Скрыть препарат (ожидаем поставщика)';
          break;
        case 'AddStatRecordToModeration':
          header = 'Отправить запись на модерацию';
          break;
      }
      this.$store.dispatch("platform/setGlobalModalData", {
        type: alias,
        headerText: header,
        record: this.record,
        callBack: () => {
          console.log('call back');
          setTimeout(() => {
            customUpdateData.$emit('updateListById', this.record.id);
          }, 200)
        }
      });
    },
    getConditionTasks() {
      return this.$refs.watchSuppliers.validate();
    },
    async updateRecordDetail(alias) {
      let postData = {};
      switch (alias) {
        case 'comment':
          postData = {
            group: 'users_data',
            alias,
            drug_id: this.record.drug_id,
            details: [this.recordDetails[alias]]
          };
          break;
      }
      this.saveLoading = true;
      const {data} = await api.post('/statistics/003/detail/update', postData);
      if (data.success) {
        toastr['success']('Сохранено', 'Успешно');
        customUpdateData.$emit('updateListById', this.record.id);
        if (this.closeDrawer) {
          // this.closeDrawer(null, true, true);
        }
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
      this.saveLoading = false;
    },
    async saveTasks(hideRecord = false) {
      if (!Object.values(this.selectedTasks).find((s) => s)) {
        toastr['warning']('Задачи не выбраны', 'Ошибка');
        return;
      }
      if (hideRecord && !this.showHideReasonBlock) {
        this.showHideReasonBlock = true;
        toastr['info']('Вы можете добавить комментарий к записи', 'Информация');
        return;
      }
      const newTasks = {};
      let passValidate = true;
      let validate
      Object.keys(this.selectedTasks).forEach((alias) => {
        if (!this.selectedTasks[alias]) return;
        if (alias === 'pairDrug') return;
        // console.log(alias, this.$refs[alias]);
        // if (this.$refs[alias] && this.$refs[alias][0]?.validate) {
        if (this.$refs[alias] && this.$refs[alias]?.validate) {
          // validate = this.$refs[alias][0].validate();
          validate = this.$refs[alias].validate();
          if (!validate.success) {
            toastr['warning'](validate.message || 'Задача не прошла валидацию', 'Ошибка');
            passValidate = false;
          } else {
            newTasks[alias] = validate.data;
          }
        } else {
          newTasks[alias] = this.newTasksData[alias];
        }
      })
      if (!passValidate) return;
      this.saveLoading = true;
      const {data} = await api.post('/tasks/stat/new', {
        hideRecord,
        hideReasonText: this.hideReasonText,
        record: {
          id: this.record.id,
          drug: {
            id: this.record.drug.id,
            group: this.record.drug.group,
            title: this.record.drug.title,
          }
        },
        tasks: newTasks
      })
      if (data.success) {
        toastr['success']('Сохранено', 'Успешно');
        if (this.closeDrawer) {
          this.closeDrawer(null, true, true);
        }
        setTimeout(() => {
          customUpdateData.$emit('updateListById', this.record?.stats_record_id ?? this.record.drug?.id ?? this.record.id);
        }, 200)
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
      this.saveLoading = false;
    }
  }
}

</script>

<style scoped>
.refresh_btn {
  position: absolute;
  z-index: 10;
  right: 10px;
  top: 10px;
}

.btn-outline-primary:hover {
  color: #007dcc;
  background-color: transparent;
}

.btn-outline-primary input {
  display: none;
}

table td {
  font-size: 18px;
}
</style>
